<template>
  <section class="contact-page flex column gap10 width-all_ align-start">
    <h2 class="inner-page-sub-header">{{$t('contactLocales.contacts')}}</h2>
    <ItemSearchList
      class="height-all table-like-list"
      :itemsData="contactDataForList"
      :initFilterBy="filterBy"
      @filter="getAllContacts"
      itemDetailesPageName="ContactDetails"
      newItemPageName="ContactEdit"
      :singlePreviewCmp="ContactPreview"
      :filterByCmp="ContactFilter"
      :showActions="false"
      :dontRoute="true"
      :isLoading="listIsLoading"
      :showLoader="false"
      :propsToPass="{
        fields: isScreenWide? undefined : ['name', 'unsubscribed']
      }"
      layoutMode="flex"
    >

      <template v-slot:filterActions>
        <div class="flex align-center gap20">
          <router-link :to="{name: 'ContactEdit', params: { organizationId: $route.params.organizationId } }"><button class="flex align-center gap10"><span class="flex align-center bold">+<div v-html="svgs.person" class="svg-parrent"></div></span><span>{{$t('addNew')}}</span></button></router-link>
          <div class="flex align-center gap10 justify-end">
            <div v-html="svgs.loadCloud" class="svg-parrent"></div>
            <FormInput
              type="file"
              accept=".xlsx, .xls, .xl, .csv"
              @change="uploadContactsFromFile"
              v-model="contactsFiles"
              placeholder="contactLocales.loadXlFile"
            />
            <Tooltip :msg_="$t('contactLocales.uploadFileTooltipMsg')">
              <template v-slot:content>
                <div class="flex gap10 column">
                  <p v-html="$t('contactLocales.uploadFileTooltipMsg').split('\n').join('<br/>')"></p>
                  <a class="clr-4" href="/files/emptyContactsFileToFill.xlsx" download="contacts for megaphon.xlsx">{{$t('contactLocales.downloadEmtyFileToFill')}}</a>
                </div>
              </template>
            </Tooltip>
          </div>
        </div>
      </template>
      <template v-slot:listHeader>
        <!-- <div class="actions">
          
        </div> -->

        <div class="table-item-preview table-header">
          <p class="wide-screen-item">{{$t('email')}}</p>
          <p>{{$t('contactLocales.contactName')}}</p>
          <p class="wide-screen-item">{{$t('contactLocales.tags')}}</p>
          <p class="wide-screen-item">{{$t('contactLocales.companyName')}}</p>
          <p>{{$t('contactLocales.unsubscribed')}}</p>
        </div>
      </template>
    </ItemSearchList>
    <Loader v-if="listIsLoading" fullScreen/>
  </section>
</template>

<script>
import ItemSearchList from '@/apps/common/modules/common/cmps/ItemSearchList/ItemSearchList.vue'
import Loader from '@/apps/common/modules/common/cmps/Loader.vue'
import ContactPreview from '../cmps/ContactPreview.vue'
import ContactFilter from '../cmps/ContactFilter.vue'
import FormInput from '../../../../common/modules/common/cmps/FormInput.vue'

import { httpService } from '@/apps/common/modules/common/services/http.service'
import Tooltip from '../../../../common/modules/common/cmps/Tooltip.vue'
import { alertService } from '@/apps/common/modules/common/services/alert.service'
import { getSvgs } from '../../../assets/images/svgs'

export default {
  name: 'ContactPage',
  data() {
    return {
      ContactPreview,
      ContactFilter,
      contactsFiles: null,
      lastLoadedFilter: null,
      isLoadingContacts: false,
      hasLoadedOnce: false
    }
  },
  computed: {
    organizationId() {
      return this.$route.params.organizationId
    },
    allContactData() {
      return this.$store.getters['contact/data']
    },
    contactDataForList() {
      // Don't reference $route here - it makes this computed reactive to route changes
      // which causes re-renders when opening/closing modal
      return this.allContactData
    },
    filterBy() {
      return this.$store.getters['contact/filterBy']
    },
    isLoading() {
      return this.$store.getters['contact/isLoading']
    },
    listIsLoading() {
      // Only show loading on first load, never after
      // This prevents re-renders when route changes or ContactEdit loads
      if (this.hasLoadedOnce) {
        return false
      }
      return this.isLoading
    },
    isScreenWide() {
      return this.$store.getters.isScreenWide
    },
    svgs() {
      return getSvgs()
    }
  },
  methods: {
    getAllContacts(filterBy) {
      // Don't reload if we're on a modal route (ContactEdit)
      if (this.$route.meta?.isModal) {
        return
      }
      
      // Don't reload if already loading (prevents double calls)
      if (this.isLoadingContacts) {
        return
      }
      
      const filter = filterBy || this.filterBy || {}
      // Add includeUnsubscribed before stringifying so the comparison includes it
      const fullFilter = {...filter, includeUnsubscribed: true}
      const filterString = JSON.stringify(fullFilter)
      
      // Don't reload if filter is the same as last loaded
      if (this.lastLoadedFilter === filterString) {
        return
      }
      
      this.isLoadingContacts = true
      this.lastLoadedFilter = filterString
      this.$store.dispatch({ type: 'contact/loadItems', filterBy: fullFilter, organizationId: this.$route.params.organizationId })
        .finally(() => {
          this.isLoadingContacts = false
          this.hasLoadedOnce = true
        })
    },
    async uploadContactsFromFile(files) {
      if (!files?.length) return;
      if (!await alertService.Confirm(this.$t('contactLocales.alerts.confirmUploadContactsFileMsg'))) {
        this.contactsFiles = null;
        return;
      }
      const mailingListName = await alertService.Prompt(this.$t('contactLocales.alerts.saveAsMailingListPromptMsg'), this.$t('name'));
      // this.$store.commit({type: 'contact/setProp', key: 'isLoading', value: true});
      this.$store.commit({type: 'contact/setLoading', key: 'isLoading', val: true});
      try {
        const data = new FormData();
        data.append('file', files[0]);
        await httpService.post(`file/uploadContacts/${this.organizationId}`, data, { mailingListName });
        alertService.toast({type: 'safe', msg: this.$t('contactLocales.alerts.uploadedContactsSuccessfully')});
      } catch(err) {
        alertService.toast({type: 'danger', msg: this.$t('contactLocales.alerts.cantUploadContactsError')});
      }
      this.contactsFiles = null;
      // this.$store.commit({type: 'contact/setProp', key: 'isLoading', value: false});
      this.$store.commit({type: 'contact/setLoading', key: 'isLoading', val: false});
      this.getAllContacts()
    }
  },
  watch: {
    organizationId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getAllContacts()
      }
    }
  },
  created() {
    this.getAllContacts()
    // Preload tags and companies only if not already loaded
    if (!this.$store.getters['tag/items']?.length) {
      this.$store.dispatch({ type: 'tag/loadItems', filterBy: { organizationId: this.organizationId, pagination: { noLimit: true } } })
    }
    if (!this.$store.getters['company/items']?.length) {
      this.$store.dispatch({ type: 'company/loadItems', filterBy: { organizationId: this.organizationId, pagination: { noLimit: true } } })
    }
  },
  components: { ItemSearchList, Loader, ContactPreview, ContactFilter, FormInput, Tooltip }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';
.megaphon-app {
  .contact-page {
    max-width: 2000px;
    padding: em(20px) 0;
    height: auto;
    position: relative;
    .actions {
      // text-align: end;
      margin-bottom: em(20px);
    }

    
    .filter-container {
      padding: em(10px);
      background-color: var(--clr-3);
    }
    .file-btn {
      text-decoration: unset !important;
    }
    // background-color: #E0E0E0;

  }
}
</style>